// extracted by mini-css-extract-plugin
export default {"Button_0":"BooleanValueSelect-module__Button_0--uEoUf","Octicon_0":"BooleanValueSelect-module__Octicon_0--lNGyL"};